import React, { ChangeEvent } from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AgentFormState } from "../../../types/agentTypes";
import { FieldColumn, FieldRow, Section, SectionTitle } from "../styles";

type ContactPersonSectionProps = {
  formData: AgentFormState;
  setFormData: React.Dispatch<React.SetStateAction<AgentFormState>>;
  onChange: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => void;
};

const ContactPersonSection = ({
  formData,
  setFormData,
  onChange,
}: ContactPersonSectionProps) => {
  const { t } = useTranslation();

  return (
    <Section>
      <SectionTitle>{t("createAgent.contactPerson.title")}</SectionTitle>

      <FieldRow>
        <FieldColumn>
          <TextField
            size="small"
            label={t("createAgent.contactPerson.fio")}
            name="contact_fio"
            value={formData.contact_fio ?? ""}
            fullWidth
            onChange={onChange}
          />
        </FieldColumn>

        <FieldColumn>
          <TextField
            type="email"
            size="small"
            label={t("createAgent.contactPerson.email")}
            name="contact_email"
            value={formData.contact_email ?? ""}
            fullWidth
            onChange={onChange}
          />
        </FieldColumn>

        <FieldColumn>
          <TextField
            size="small"
            label={t("createAgent.contactPerson.phone")}
            name="contact_phone"
            value={formData.contact_phone ?? ""}
            fullWidth
            required
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              const value = event.target.value;
              const numbersOnly = value.replace(/\D/g, "");

              setFormData((prev) => ({
                ...prev,
                contact_phone: numbersOnly,
              }));
            }}
          />
        </FieldColumn>
      </FieldRow>
    </Section>
  );
};

export default ContactPersonSection;
